import { useTranslation } from "react-i18next";

import "components/NavBarSearchAppointments/components/SearchResultsDivider/SearchResultsDivider.scss";

export const SearchResultsDivider = () => {
  const { t } = useTranslation();

  return (
    <div className="other-locations-container">
      <div className="other-locations-divider" />
      <div className="other-locations-text-container">
        <span>{t("v8_other_locations", "Other Locations")}</span>
      </div>
      <div className="other-locations-divider" />
    </div>
  );
};
